import {
	CopyControl,
	Dialog,
	Form,
	FormItem
} from "client/Components";
import { useOpenDialog } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { ReactElement } from "react";

export type TileGroupEmbedUrlDialogProps = {
	tileGroupId: number;
	onClose: () => void;
};

export const TileGroupEmbedUrlDialog = (props: TileGroupEmbedUrlDialogProps): ReactElement => {
	const {
		tileGroupId,
		onClose
	} = props;

	return (
		<Dialog trackingId="tile-group-embed-url-dialog">
			<Dialog.Header
				title={localize("_GetEmbedUrl")}
				onClose={onClose}
			/>

			<Dialog.Body>
				<Form onSubmit="NONE">
					<p>
						{localize("_UseTheEmbedUrlToEmbedTheTileGroupOnAnotherWebsite")}
					</p>
					<FormItem>
						<CopyControl
							trackingId="url"
							value={createUrlRelativeToEnvironment(`/Workspace/EmbedTileGroup/${tileGroupId}/`)}
							buttonKind="primary"
						/>
					</FormItem>
				</Form>
			</Dialog.Body>

			<Dialog.Footer />
		</Dialog>
	);
};
TileGroupEmbedUrlDialog.displayName = "TileGroupEmbedUrlDialog";

export function useTileGroupEmbedUrlDialog(): [
	element: ReactElement | null,
	open: (data: Omit<TileGroupEmbedUrlDialogProps, "onClose">) => Promise<void>
] {
	return useOpenDialog<Omit<TileGroupEmbedUrlDialogProps, "onClose">>(
		(data, onClose) => (
			<TileGroupEmbedUrlDialog
				{...data}
				onClose={onClose}
			/>
		)
	);
}